import Cockpit from "./Cockpit"
import Ovni from "./Ovni"
import Pipe from "./Pipe"
import TextActTwo from "./TextActeTwo"

import { moveAxisRange, scaleRange } from '../../../utils/moveObjects'
import { useActsStore } from "../../../store/useActsStore"
import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import Sun from "./Sun"
import { useSceneRef } from "../../../RefsProvider"
import { useIsMobile } from "../../../utils/useIsMobile"
import Lines from "./Lines"


export default function ActeTwoModels() {

    const ovni = useRef()
    const acteTwoModelRefBloom = useSceneRef("acteTwoModelRef")
    const isMobile = useIsMobile()
    const sun = useRef()

    useFrame((_, delta) => {
        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()
        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0
        const ovniOffsetX = isMobile ? 22 : 20
        if (id === 1) {
            moveAxisRange(ovni, 'x', 0, ovniOffsetX, holdProgress, 0.2, 0.5, 1, delta)
            moveAxisRange(ovni, 'y', 0, -0.8, holdProgress, 0.15, 0.18, 1, delta, false)
            moveAxisRange(ovni, 'y', -0.8, 0.8, holdProgress, 0.18, 0.3, 1, delta, false)
        }
        if(id===1 && isMobile) {
             scaleRange(ovni,1, -1, holdProgress, 0.4,0.65, 1, delta)
        }
    })

    return (
        <>
            <TextActTwo position={[3.5, 0.4, 2.5]} />
            <Pipe position={[-6, 6.5, -4]} />
            <Lines></Lines>
            <group>
                <group ref={ovni} scale={1}>
                    <Cockpit scale={30} />
                    <Ovni position={[-2, -2, -4]} scale={1} />
                </group>
                <Sun scale={2} position={[20, 0, -4]} />
            </group>

        </>
    )
}